<template>

    <v-card v-observe-visibility="visibilityChanged">
        <v-toolbar light color="white">
            <v-btn icon @click.native="closeNewCustomerDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedCustomer.id === 0">Add New Customer</v-toolbar-title>
            <v-toolbar-title v-else>Edit Customer - {{selectedCustomer.name}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs
                v-model="activeTab"
                color="secondary"
                dark
                slider-color="primary"
        >
            <v-tab>Customer</v-tab>
            <v-tab-item>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-card dark color="secondary">
                                            <v-card-title>General</v-card-title>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedCustomer.name"
                                                label="Name">
                                        </v-text-field>
                                    </v-flex>

                                </v-layout>

                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-card dark color="secondary">
                                            <v-card-title>Optional Info</v-card-title>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedCustomer.website"
                                                label="Website">
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedCustomer.email"
                                                label="E-Mail">
                                        </v-text-field>
                                    </v-flex>

                                </v-layout>

                                <v-layout mt-5 row justify-end>
                                    <v-btn mt-5 dark color="secondary" @click.native="saveCustomerAndGoToNextTab(1)">
                                        Save
                                        <v-icon class="white--text" right>save</v-icon>
                                    </v-btn>
                                </v-layout>

                            </v-flex>

                        </v-layout>


                    </v-container>
                </v-card-text>
            </v-tab-item>

            <!--Branch office settings-->
            <v-tab :disabled="branchOfficeTabActive">Branch Offices</v-tab>
            <v-tab-item>
                <branch-offices></branch-offices>
            </v-tab-item>

            <!--Contact persons settings-->
            <v-tab :disabled="contactPersonsTabActive">Contact Persons</v-tab>
            <v-tab-item>
                <contact-persons></contact-persons>
            </v-tab-item>

            <!--Bank accounts settings-->
            <v-tab :disabled="bankAccountsTabActive">Bank Accounts</v-tab>
            <v-tab-item>
                <bank-accounts></bank-accounts>
            </v-tab-item>


        </v-tabs>

    </v-card>

</template>


<script>
    import {
        Settings,
        Customer,
        CustomerBranchOffice
    } from '../../store/namespace-helper'
    import BranchOffices from '../Customers/CustomerBranchOffices.vue'
import ContactPersons from '../Customers/CustomerContactPersons.vue'
import BankAccounts from '../Customers/CustomerBankAccounts.vue'

    export default {
      components: {
        ContactPersons,
        BranchOffices,
        BankAccounts
      },
      name: 'add-new-customer',
      data () {
        return {
          activeTab: 0,
          countries: this.$store.getters.countries,
          salutions: [
            'Mr.',
            'Mrs.',
            'Company'
          ],
          isVisible: false,
          supplierContact: {},
          supplierUpdated: 0,
          onDismissed: false,
          sheet: false
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadCustomerBranchOffices()
            } else {
              this.supplierUpdated = 0
            }
          }
        },
        closeNewCustomerDialog () {
          this.$store.dispatch(Customer.actions.setSelectedCustomer, null)
          this.$store.dispatch(CustomerBranchOffice.actions.setSelectedBranchOffice, null)
          this.$store.dispatch(Customer.actions.openCloseNewCustomerDialog)
          this.activeTab = 0
        },
        loadCustomerBranchOffices () {
          this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedCustomer.id)
        },
        saveCustomerAndGoToNextTab (index) {
          this.$store.dispatch(Customer.actions.saveCustomers, this.selectedCustomer)
          this.activeTab = index
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        }
      },
      computed: {
        dialog () {
          return this.$store.getters[Customer.getters.getOpenNewCustomerDialogState]
        },
        selectedCustomer () {
          console.log('selected cusomter: ' + JSON.stringify(this.$store.getters[Customer.getters.getSelectedCustomer]))
          return this.$store.getters[Customer.getters.getSelectedCustomer]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        branchOfficeTabActive () {
          return this.$store.getters[Customer.getters.getSelectedCustomer].id === 0
        },
        contactPersonsTabActive () {
          if (this.$store.getters[CustomerBranchOffice.getters.getSelectedBranchOffice] === null) {
            return true
          } else {
            if (this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices].length <= 0) {
              return true
            } else {
              return false
            }
          }
        },
        bankAccountsTabActive () {
          if (this.$store.getters[CustomerBranchOffice.getters.getSelectedBranchOffice] === null) {
            return true
          } else {
            if (this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices].length <= 0) {
              return true
            } else {
              return false
            }
          }
        }
      }
    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Shared/AddCustomer.vue